import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';

import ReactGA from 'react-ga4';

// Import komponen lainnya
// import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Carousel from './components/Beranda/Carousel';
import AboutMe from './components/Beranda/AboutMe';
import MediaCard from './components/Media/MediaCard';
import BannerFooter from './components/Beranda/BannerFooter';
// import DekomDireksi from './components/DekomDireksi';
import PalapaRingTengah from './components/Beranda/PalapaRingTengah';
import PenggunaLayanan from './components/Beranda/PenggunaLayanan';
import KontakKami from './components/KontakKami/KontakKami';
// import SkemaBisnis from './components/SkemaBisnis';
import MediaLayout from './components/Media/MediaLayout';
import MediaSection from './components/Media/MediaSection';
import MediaDetail from './components/Media/MediaDetail';
import PublicationSection from './components/Media/PublicationSection';


import TentangPerusahaanLayout from './components/Perusahaan/TentangPerusahaan/TentangPerusahaanLayout';
import ManajemenLayout from './components/Perusahaan/Manajemen/ManajemenLayout';

import PedomanStrukturGCGLayout from './components/Perusahaan/TataKelolaPerusahaan/Pedoman&StrukturGCG/PedomanStrukturGCGLayout';
import ImplementasiGCGLayout from './components/Perusahaan/TataKelolaPerusahaan/ImplementasiGCG/ImplementasiGCGLayout';
import BoardManualLayout from './components/Perusahaan/TataKelolaPerusahaan/BoardManual/BoardManualLayout';
import KodeEtikTataPerilakuLayout from './components/Perusahaan/TataKelolaPerusahaan/KodeEtik&TataPerilaku/KodeEtikTataPerilakuLayout';
import GratifikasiBenturanKepentinganLayout from './components/Perusahaan/TataKelolaPerusahaan/Gratifikasi&BenturanKepentingan/GratifikasiBenturanKepentinganLayout';
import SistemPengaduanPelanggaranLayout from './components/Perusahaan/TataKelolaPerusahaan/SistemPengaduanPelanggaran/SistemPengaduanPelanggaranLayout';
import PiagamCharterLayout from './components/Perusahaan/TataKelolaPerusahaan/PiagamCharter/PiagamCharterLayout';
import KomitePerusahaanLayout from './components/Perusahaan/TataKelolaPerusahaan/KomitePerusahaan/KomitePerusahaanLayout';
import SistemManajemenLayout from './components/Perusahaan/TataKelolaPerusahaan/SistemManajemen/SistemManajemenlayout';

import PalapaRingLayout from './components/PalapaRing/PalapaRingLayout';
import Pengadaan from './components/Pengadaan/Pengadaan';
import HomeLayout from './components/Beranda/HomeLayout';
import CsirtPage from './components/Csirt/CsirtPage';


const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return null;
};

function App() {
  const turnstileRef = useRef(null);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {

    const storedVerification = localStorage.getItem('isVerified');
    const verificationTimestamp = localStorage.getItem('verificationTime');

    const now = new Date().getTime();

    if (storedVerification === 'true' && verificationTimestamp) {
      const elapsedTime = now - parseInt(verificationTimestamp, 10);

      // Check if 1 hour has passed since verification
      if (elapsedTime < 60 * 60 * 1000) { // 1 hour in milliseconds
        setIsVerified(true);
      } else {
        // Reset verification if time exceeds 1 hour
        localStorage.removeItem('isVerified');
        localStorage.removeItem('verificationTime');
        setIsVerified(false);
      }
    } else {

      // Interval untuk memastikan `window.turnstile` tersedia
      const interval = setInterval(() => {
        if (window.turnstile && turnstileRef.current) {
          window.turnstile.render(turnstileRef.current, {
            sitekey: "0x4AAAAAAAsfHjcLuIrJmLy3", // Replace with your Site Key
            callback: (newToken) => {
              setIsVerified(true);
              const timestamp = new Date().getTime();
              localStorage.setItem('isVerified', 'true'); // Simpan status verifikasi
              localStorage.setItem('verificationTime', timestamp.toString()); // Simpan waktu verifikasi
            },
            'error-callback': () => {
              console.error("Turnstile error: Failed to verify user.");
              setIsVerified(false); // Reset status jika terjadi error
            },
            'expired-callback': () => {
              console.warn("Turnstile expired: Please try again.");
              setIsVerified(false); // Reset status jika token kadaluarsa
            },
          });
          clearInterval(interval); // Hentikan pengecekan setelah berhasil
        }
      }, 100);

      return () => clearInterval(interval); // Hentikan interval saat komponen di-unmount
    }
  }, []);

  return (
    <Router>
      <TrackPageView />
      <div>
        <>
          {/* Navbar selalu tampil */}
          <Navbar />

          {/* Routes untuk mengelola konten utama */}
          <Routes>
            {/* Halaman Utama */}
            <Route path="/" element={
              <>
                {/* Preloader hanya muncul saat halaman pertama kali dimuat */}
                {/* <Preloader /> */}
                <Carousel />
                <AboutMe />
                <MediaCard />
                <PalapaRingTengah />
                <PenggunaLayanan />
                <BannerFooter />
              </>
            } />
            {/* Halaman Utama */}
            <Route path="/" element={<HomeLayout />} />

            <Route path="/tentang-perusahaan" element={<TentangPerusahaanLayout />} />
            <Route path="/manajemen" element={<ManajemenLayout />} />

            <Route path="/tata-kelola-perusahaan/pedoman-struktur-gcg" element={<PedomanStrukturGCGLayout />} />
            <Route path="/tata-kelola-perusahaan/implementasi-gcg" element={<ImplementasiGCGLayout />} />
            <Route path="/tata-kelola-perusahaan/board-manual" element={<BoardManualLayout />} />
            <Route path="/tata-kelola-perusahaan/kode-etik-tata-perilaku" element={<KodeEtikTataPerilakuLayout />} />
            <Route path="/tata-kelola-perusahaan/gratifikasi-benturan-kepentingan" element={<GratifikasiBenturanKepentinganLayout />} />
            <Route path="/tata-kelola-perusahaan/sistem-pengaduan-pelanggaran" element={<SistemPengaduanPelanggaranLayout />} />
            <Route path="/tata-kelola-perusahaan/piagam-charter" element={<PiagamCharterLayout />} />
            <Route path="/tata-kelola-perusahaan/komite-perusahaan" element={<KomitePerusahaanLayout />} />
            <Route path="/tata-kelola-perusahaan/sistem-manajemen" element={<SistemManajemenLayout />} />

            <Route path="/pengadaan" element={<Pengadaan />} />
            <Route path="/palapa-ring" element={<PalapaRingLayout />} />
            <Route path="/csirt" element={<CsirtPage />} />

            <Route path="/media/publikasi" element={<PublicationSection />} />
            <Route path="/media/publikasi/annual-report" element={<PublicationSection type="annual_report" />} />

            {/* Parent route untuk media */}
            <Route path="/media/:jenis" element={<MediaLayout />}>
              {/* Child route untuk daftar artikel berdasarkan jenis */}
              <Route index element={<MediaSection />} />
              {/* Child route untuk detail artikel berdasarkan jenis dan id */}
              <Route path=":slug" element={<MediaDetail />} />
            </Route>

            <Route path="/kontak-kami" element={<KontakKami />} />
          </Routes>


          {/* Footer selalu tampil */}
          <Footer />
        </>
      </div>
    </Router>
  );
}

export default App;
